module.exports = __webpack_public_path__ + "static/img/gpt61.a9dacc12.png";